import { render, staticRenderFns } from "./view-dpd.vue?vue&type=template&id=485618d2&"
import script from "./view-dpd.vue?vue&type=script&lang=js&"
export * from "./view-dpd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "view-dpd.vue"
export default component.exports